(() => {
  if (!customElements.get('trh-support-tools')) {
    class SupportTools extends HTMLElement {
      connectedCallback() {
        if (this.events || this.dataset.supportKind !== 'faqs') return;
        this.events = new AbortController();
        const opts = { signal: this.events.signal };
        this.search = this.querySelector('input[type="search"]');
        this.questions = [...this.querySelectorAll('[data-faq-category]')];
        this.index = this.questions.map(element => ({ element, text: element.textContent.toLowerCase() }));
        this.category = 'all'; this.original = new Map();
        this.querySelector('.trh-faq-filters').hidden = false;
        this.search.addEventListener('input', () => this.filter(), opts);
        this.querySelector('[data-search-clear]').addEventListener('click', () => { this.search.value = ''; this.filter(); this.search.focus(); }, opts);
        this.querySelectorAll('[data-faq-filter]').forEach(button => button.addEventListener('click', () => {
          this.setCategory(button.dataset.faqFilter);
        }, opts));
        this.querySelector('[data-faq-select]')?.addEventListener('change', event => this.setCategory(event.target.value), opts);
        document.addEventListener('shopify:block:select', event => {
          const question = event.target.closest?.('[data-faq-category]');
          if (question && this.contains(question)) {
            this.search.value = ''; this.setCategory('all'); question.hidden = false; question.open = true;
          }
        }, opts);
        this.filter();
      }
      setCategory(category) {
        this.category = category;
        this.querySelectorAll('[data-faq-filter]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.faqFilter === category)));
        const select = this.querySelector('[data-faq-select]');
        if (select) select.value = category;
        this.filter();
      }
      filter() {
        const query = this.search.value.trim().toLowerCase(); let count = 0;
        if (query && !this.original.size) this.questions.forEach(question => this.original.set(question, question.open));
        for (const { element, text } of this.index) {
          const match = (this.category === 'all' || element.dataset.faqCategory === this.category) && (!query || text.includes(query));
          element.hidden = !match;
          if (match) count++;
          if (query && match) element.open = true;
          else if (!query && this.original.has(element)) element.open = this.original.get(element);
        }
        if (!query) this.original.clear();
        this.querySelector('[data-faq-result]').textContent = `${count} ${count === 1 ? 'question' : 'questions'}`;
        this.querySelector('.trh-faq-empty').hidden = count !== 0;
      }
      disconnectedCallback() {
        this.events?.abort(); this.events = null;
        this.querySelector('.trh-faq-filters')?.setAttribute('hidden', '');
        this.questions?.forEach(question => { question.hidden = false; });
      }
    }
    customElements.define('trh-support-tools', SupportTools);
  }
  const formKey = Symbol.for('trh.support.form');
  if (document[formKey]) return;
  document[formKey] = true;
  function fillRequest() {
    const form = document.getElementById('ContactForm');
    if (!form || form.dataset.requestFilled) return;
    form.dataset.requestFilled = 'true';
    const params = new URLSearchParams(location.search);
    const model = params.get('model')?.toUpperCase();
    const topic = params.get('topic');
    const modelInput = form.querySelector('[name="contact[Product model]"]');
    const topicInput = form.querySelector('[name="contact[Support topic]"]');
    if (modelInput && [...modelInput.options].some(option => option.value === model)) modelInput.value = model;
    if (topicInput && [...topicInput.options].some(option => option.value === topic)) topicInput.value = topic;
    const businessDetails = form.querySelector('.trh-contact-business');
    const showBusiness = () => {
      if (businessDetails && ['quote', 'distributor', 'affiliate'].includes(topicInput?.value)) businessDetails.open = true;
    };
    topicInput?.addEventListener('change', showBusiness);
    showBusiness();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillRequest, { once: true });
  else fillRequest();
  document.addEventListener('shopify:section:load', fillRequest);
})();
